import {
    List,
    Datagrid,
    TextField,
    DateField,
} from 'react-admin';

export const AddressList = () => (
    <List>
        <Datagrid>
            <TextField source="id" sortable={false} />
            <TextField source="user_id" sortable={false} />
            <TextField source="first_name" sortable={false} />
            <TextField source="last_name" sortable={false} />
            <TextField source="phone_number" sortable={false} />
            <TextField source="street1" sortable={false} />
            <TextField source="street2" sortable={false} />
            <TextField source="city" sortable={false} />
            <TextField source="province" sortable={false} />
            <TextField source="postal_code" sortable={false} />
            <TextField source="is_default" sortable={false} />
            <TextField source="save_address" sortable={false} />
            <DateField source="CreatedAt" showTime={true} sortable={false} />
            <DateField source="UpdatedAt" showTime={true} sortable={false} />
        </Datagrid>
    </List>
);